import React from 'react';

const CheckinGuide = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900">📋 คู่มือการ Check-in</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Scenario */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-blue-900 mb-2">🎯 สถานการณ์: น้องเดินมาถึงหน้างาน</h3>
            <p className="text-blue-800 text-sm">
              น้องเดินมาถึงหน้างานของลูกค้าแล้ว ต้องการ check-in เข้าร่วมกิจกรรม
            </p>
          </div>

          {/* Method 1: Manual */}
          <div className="mb-6">
            <div className="flex items-center space-x-3 mb-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">1</div>
              <h3 className="text-lg font-semibold text-gray-900">👥 Manual Check-in (แนะนำ)</h3>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 mb-3">
              <h4 className="font-medium text-gray-900 mb-2">ขั้นตอน:</h4>
              <ol className="text-sm text-gray-700 space-y-1">
                <li>1. ผู้จัด/ผู้ช่วยจัด เปิดหน้า check-in ของทริปนี้</li>
                <li>2. เลือก "Manual Check-in"</li>
                <li>3. หาชื่อน้องในรายการ "น้องๆ"</li>
                <li>4. กดปุ่ม "Check-in" ข้างชื่อน้อง</li>
                <li>5. ✅ น้อง check-in สำเร็จทันที!</li>
              </ol>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
              <p className="text-green-800 text-sm">
                <strong>ข้อดี:</strong> ง่าย รวดเร็ว ไม่ต้องใช้มือถือ ไม่ต้องสแกน QR
              </p>
            </div>
          </div>

          {/* Method 2: QR Code */}
          <div className="mb-6">
            <div className="flex items-center space-x-3 mb-3">
              <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">2</div>
              <h3 className="text-lg font-semibold text-gray-900">📱 QR Code Check-in</h3>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 mb-3">
              <h4 className="font-medium text-gray-900 mb-2">ขั้นตอน:</h4>
              <ol className="text-sm text-gray-700 space-y-1">
                <li>1. ผู้จัด กดปุ่ม "สร้าง QR Code"</li>
                <li>2. แสดง QR Code ให้น้องดู</li>
                <li>3. น้องเปิดมือถือไปที่ <code className="bg-gray-200 px-1 rounded">/scan-qr</code></li>
                <li>4. กดปุ่ม "เปิดกล้องสแกน QR Code"</li>
                <li>5. สแกน QR Code ที่ผู้จัดแสดงให้</li>
                <li>6. ✅ ระบบ check-in อัตโนมัติ!</li>
              </ol>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-blue-800 text-sm">
                <strong>ข้อดี:</strong> น้องสามารถ check-in เองได้ ไม่ต้องรอผู้จัด
              </p>
            </div>
          </div>

          {/* Quick Access */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-yellow-900 mb-2">🚀 เข้าถึงเร็ว:</h4>
            <div className="space-y-2 text-sm">
              <p className="text-yellow-800">
                <strong>สำหรับน้อง:</strong> กดปุ่ม "📱 Scan QR" ในเมนูหลัก
              </p>
              <p className="text-yellow-800">
                <strong>สำหรับผู้จัด:</strong> กดปุ่ม "📱 Check-in" ในรายการทริป
              </p>
            </div>
          </div>

          {/* Tips */}
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <h4 className="font-semibold text-purple-900 mb-2">💡 เคล็ดลับ:</h4>
            <ul className="text-sm text-purple-800 space-y-1">
              <li>• Manual Check-in เหมาะสำหรับสถานการณ์ที่ต้องการความรวดเร็ว</li>
              <li>• QR Code เหมาะสำหรับน้องที่ใช้มือถือคล่อง</li>
              <li>• สามารถใช้ทั้งสองวิธีพร้อมกันได้</li>
              <li>• ระบบจะบันทึกการ check-in ทั้งหมดอัตโนมัติ</li>
            </ul>
          </div>

          {/* Close Button */}
          <div className="mt-6 text-center">
            <button
              onClick={onClose}
              className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
            >
              เข้าใจแล้ว!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckinGuide;




